import WPStagingCommon from '../../wpstg.js';
import {qs} from '../../modules/wpstg-dom-utils.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupUpload;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupUpload.listen();
  });

  WPStagingBackupUpload = {
    isUploading: false,
    resumable: null,
    resumableFile: null,

    listen() {
      document.body.addEventListener('click', function(event) {
        if (event.target.id === 'wpstg-upload-backup') {
          WPStagingBackupUpload.uploadModal();
        }
      });
    },

    /**
     * @see https://caniuse.com/fileapi
     */
    uploadNotSupported() {
      WPStagingCommon.showErrorModal('Your browser do not support the File API, needed for the uploads. Please try a different/updated browser, or upload the Backup using FTP to the folder <strong>wp-content/uploads/wp-staging/backups</strong>');
    },

    setModalStateStart() {
      WPStagingBackupUpload.isUploading = false;
      qs('.wpstg--swal2-container #wpstg-upload-select').style.display = 'block';
      qs('.wpstg--swal2-container #wpstg-upload-progress').style.display = 'none';
      qs('.wpstg--swal2-container .wpstg--modal--backup--import--upload--content .wpstg-linear-loader').style.display = 'none';
    },

    setModalStateUploading() {
      WPStagingBackupUpload.isUploading = true;
      qs('.wpstg--swal2-container #wpstg-upload-select').style.display = 'none';
      qs('.wpstg--swal2-container #wpstg-upload-progress').style.display = 'block';
      qs('.wpstg--swal2-container .wpstg--modal--backup--import--upload--content .wpstg-linear-loader').style.display = 'block';
      qs('.wpstg--swal2-container .wpstg--modal--import--upload--process').style.display = 'flex';

      const _btnCancel = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg--swal2-cancel wpstg--btn--cancel')[0];
      const btnCancel = _btnCancel.cloneNode(true);
      _btnCancel.parentNode.replaceChild(btnCancel, _btnCancel);

      btnCancel.addEventListener('click', WPStagingBackupUpload.eventListenerConfirmCancelUpload);
    },

    eventListenerConfirmCancelUpload() {
      if (confirm('Do you want to abort the upload?')) {
        WPStagingBackupUpload.resumable.cancel();
        WPStagingCommon.closeSwalModal();
        WPStagingBackupUpload.deleteUnfinishedUploads();
      }
    },

    deleteUnfinishedUploads() {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--uploads-delete-unfinished',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
          },
          function(response) {
          // no-op
          },
      );
    },

    uploadModal() {
      WPStagingCommon.getSwalModal(true).fire({
        html: document.getElementById('wpstg--modal--backup--upload').innerHTML,
        showConfirmButton: false,
        showCloseButton: false,
        showLoaderOnConfirm: false,
        showCancelButton: true,
        width: 650,
        allowEscapeKey: () => {
          return !WPStagingBackupUpload.isUploading;
        },
        allowOutsideClick: () => {
          return !WPStagingBackupUpload.isUploading;
        },
        onRender() {
          WPStagingBackupUpload.deleteUnfinishedUploads();
          WPStagingBackupUpload.setModalStateStart();

          WPStagingBackupUpload.resumable = new Resumable({
            target: wpstg.ajaxUrl,
            chunkSize: wpstg.maxUploadChunkSize,
            query: {
              accessToken: wpstg.accessToken,
              action: 'wpstg--backups--import--file-upload',
              uniqueIdentifierSuffix: Math.floor(Math.random() * 99999999),
            },
            permanentErrors: [400, 401, 403, 404, 409, 415, 500, 501, 507, 413], // These will STOP the upload. Other errors will retry the chunk.
            fileType: ['wpstg'],
            simultaneousUploads: 1,
            prioritizeFirstAndLastChunk: false,
            testChunks: false,
            forceChunkSize: true,
          });
          WPStagingBackupUpload.resumable.resumableFile = null;

          if (!WPStagingBackupUpload.resumable.support) {
            WPStagingCommon.closeSwalModal();
            WPStagingBackupUpload.uploadNotSupported();

            return;
          }

          WPStagingBackupUpload.resumable.assignBrowse(qs('.wpstg--swal2-container .resumable-browse'));
          WPStagingBackupUpload.resumable.assignDrop(qs('.wpstg--swal2-container .resumable-drop'));

          WPStagingBackupUpload.resumable.on('fileAdded', WPStagingBackupUpload.handleFileAdded);
          WPStagingBackupUpload.resumable.on('fileSuccess', WPStagingBackupUpload.handleFileSuccess);
          WPStagingBackupUpload.resumable.on('error', WPStagingBackupUpload.handleError);
          WPStagingBackupUpload.resumable.on('progress', WPStagingBackupUpload.handleProgress);
        },
      });
    },

    handleFileAdded(file) {
      WPStagingBackupUpload.setModalStateUploading();

      WPStagingBackupUpload.resumable.resumableFile = file;
      WPStagingBackupUpload.resumable.upload();
    },

    handleFileSuccess(file, message) {
      WPStagingCommon.closeSwalModal();
      WPStagingCommon.showSuccessModal(qs('#wpstg--modal--backup--upload').getAttribute('data-uploadSuccessMessage', 'Upload finished'));
      WPStagingBackup.fetchListing();
    },

    handleProgress() {
      const percent = Math.floor(WPStagingBackupUpload.resumable.progress() * 100);

      qs('.wpstg--swal2-container .wpstg--modal--import--upload--progress').style.width = percent + '%';
      qs('.wpstg--swal2-container .wpstg--modal--import--upload--progress--title > span').textContent = percent + '%';
    },

    handleError(message, file) {
      try {
        const json = JSON.parse(message);

        if (json.hasOwnProperty('data') && json.data.hasOwnProperty('message') ) {
          if (json.data.hasOwnProperty('isDiskFull') && json.data.isDiskFull) {
            WPStagingBackupUpload.resumable.cancel();
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showErrorModal(json.data.message);
            return;
          }

          if (json.data.hasOwnProperty('backupFailedValidation') && json.data.backupFailedValidation) {
            WPStagingBackupUpload.resumable.cancel();
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showErrorModal(json.data.message);
            return;
          }
        }
      } catch (e) {
        // not a JSON message, no-op
      }

      // Reduce chunk by 10%, with a minimum of 256kb reduction
      const reduceChunkBytes = Math.max(256 * 1024, WPStagingBackupUpload.resumable.opts.chunkSize * 0.1);

      WPStagingBackupUpload.resumable.opts.chunkSize = Math.ceil(WPStagingBackupUpload.resumable.opts.chunkSize - reduceChunkBytes);

      if (WPStagingBackupUpload.resumable.opts.chunkSize < 64 * 1024) {
        WPStagingCommon.closeSwalModal();
        WPStagingCommon.showErrorModal('We could not upload the backup file, please try uploading it directly using FTP to the folder wp-content/uploads/wp-staging/backups. Please also make sure you have enough free disk space on the server.');
      }

      WPStagingBackupUpload.deleteUnfinishedUploads();

      console.log(WPStagingBackupUpload.resumable.opts.chunkSize);
      WPStagingBackupUpload.resumable.files[0].retry();
    },
  };
}(jQuery));

export default WPStagingBackupUpload;
